<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.templates')}`">
              <div class="v-table">
                <TableServer type="templates" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-template')}`">
              <TemplateForm v-if="spawnerAdminSchemas.forms['Template']" />
            </b-tab>
            <b-tab
              v-if="templateId !== null && adminTemplate.id > 0"
              :title="`${this.$i18n.t('JSON.template')}#${templateId}`"
            >
              <TemplateForm
                v-if="spawnerAdminSchemas.forms['Template']"
                :template="adminTemplate"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    TemplateForm: () => import('@/components/admin/spawner/modals/forms/TemplateForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    templateId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      adminTemplate: (state) => state.adminTemplate.adminTemplate,
    }),

    modalId() {
      return 'template';
    },
  },

  watch: {
    templateId(newValue) {
      if (newValue !== null) {
        this.loadSpawnerAdminTemplate();
      }
    },
  },

  methods: {
    ...mapActions(['getSpawnerAdminTemplate']),

    async loadSpawnerAdminTemplate() {
      try {
        await this.getSpawnerAdminTemplate({
          params: {
            tid: this.templateId,
          },
        });

        // console.log('template', this.template);

        // success
        // console.log('success loading template!');
      } catch (error) {
        // error
        // console.log('error loading template!');
      }
    },

    onOpened() {
      if (this.templateId !== null) {
        this.loadSpawnerAdminTemplate();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
